export enum Accommodation {
  hotel = "hotel",
  residence = "residence",
}

export enum Instruction {
  bellBoy = "bellBoy",
  leaveWithFrontDesk = "leaveWithFrontDesk",
  leaveAtTheDoor = "leaveAtTheDoor",
  skiValet = "skiValet",
  other = "other",
}
